import { createContext, useContext, useEffect, useReducer } from "react";
import { POSTS_API } from "../../utils/API";
import postsAction from "../actions/posts.action";
import postsReducer from "../reducers/posts.reducer";
import { UseAuthContext } from "./auth.context";
import { useUIContext } from "./ui.context";

const initialState = {
  recents: [],
  liked: [],
  rated: [],
  viewed: [],
  post: null,
};
const Posts = createContext(initialState);

export const PostsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(postsReducer, initialState);
  const { loadingEnd, loadingStart } = useUIContext();
  const { token } = UseAuthContext();

  //
  const getRecents = async (offset, limit, isPrivate = false) => {
    // if (!offset || !limit) return;
    loadingStart();
    return await fetch(POSTS_API.recent + `offset=${+offset}&limit=${+limit}`)
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return !isPrivate
          ? dispatch({ type: postsAction.SET_RECENTS, payload: result })
          : result;
      })
      .catch((error) => {
        console.log("error", error);
        loadingEnd();
      });
  };
  const getViewed = async (offset, limit, isPrivate = false) => {
    loadingStart();
    return await fetch(POSTS_API.viewed + `offset=${offset}&limit=${limit}`)
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return !isPrivate
          ? dispatch({ type: postsAction.SET_VIEWED, payload: result })
          : result;
      })
      .catch(loadingEnd);
  };
  const getLiked = async (offset, limit, isPrivate = false) => {
    loadingStart();
    return await fetch(POSTS_API.liked + `offset=${offset}&limit=${limit}`)
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return !isPrivate
          ? dispatch({ type: postsAction.SET_LIKED, payload: result })
          : result;
      })
      .catch(loadingEnd);
  };
  const getRated = async (offset, limit, isPrivate = false) => {
    loadingStart();
    return await fetch(POSTS_API.rated + `offset=${offset}&limit=${limit}`)
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return !isPrivate
          ? dispatch({ type: postsAction.SET_RATED, payload: result })
          : result;
      })
      .catch(loadingEnd);
  };
  const getPostBody = async (id) => {
    loadingStart();
    return await fetch(POSTS_API.detail + `?id=${id}`)
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };
  const getPost = async (id) => {
    loadingStart();
    return await fetch(POSTS_API.single_post + `id=${id}`)
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };
  const setViews = async (id) => {
    loadingStart();
    return await fetch(POSTS_API.view + id, {
      method: "GET",
      headers: {
        Authorization: `bearer ${token}`,
      },
    })
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };
  const searchPosts = async (offset, limit, query) => {
    loadingStart();
    return await fetch(
      POSTS_API.search + `offset=${offset}&limit=${limit}&search=${query}`
    )
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };

  const setComment = async (comment) => {
    console.log(comment);
    loadingStart();
    return await fetch(POSTS_API.set_comment, {
      method: "POST",
      headers: {
        Authorization: `bearer ${token}`,
      },
      body: JSON.stringify(comment),
    })
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };
  const getComments = async (offset, limit, id) => {
    loadingStart();
    return await fetch(
      POSTS_API.comment + `offset=${offset}&limit=${limit}&postID=${id}`
    )
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };
  const getUser = async (id) => {
    loadingStart();
    return await fetch(POSTS_API.get_user + id)
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };
  const getUserPosts = async (offset, limit, id) => {
    loadingStart();
    return await fetch(
      POSTS_API.user_post + `offset=${offset}&limit=${limit}&userID=${id}`
    )
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };

  //
  const deletePost = async (id) => {
    loadingStart();
    return await fetch(POSTS_API.delete + id, {
      method: "DELETE",
      headers: {
        Authorization: `bearer ${token}`,
      },
    })
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return getRecents(0, 10);
      })
      .catch(loadingEnd);
  };

  const updatePost = async (id, data, img) => {
    loadingStart();
    return await fetch(POSTS_API.update + id, {
      method: "PUT",
      headers: {
        Authorization: `bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => (response.ok ? response.json() : ""))
      .then(async (result) => {
        if (img.img) {
          const form = new FormData();
          form.append("file", img.img);
          console.log(img.img);
          return await fetch(
            "https://mediumuz.herokuapp.com/api/post/upload-image?id=" +
              result.data,
            {
              method: "PATCH",
              body: form,
              headers: {
                Authorization: `bearer ${state.token}`,
              },
            }
          )
            .then((response) => (response.ok ? response.json() : ""))
            .then((result) => {
              loadingEnd();
              return result;
            })
            .catch(loadingEnd);
        }
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };

  const getAuthor = async (id) => {
    loadingStart();
    return await fetch(POSTS_API.author + id)
      .then((response) => (response.ok ? response.json() : ""))
      .then((result) => {
        loadingEnd();
        return result;
      })
      .catch(loadingEnd);
  };

  useEffect(() => {}, []);
  return (
    <Posts.Provider
      value={{
        ...state,
        getRecents,
        getViewed,
        getLiked,
        getRated,
        getPostBody,
        getPost,
        deletePost,
        updatePost,
        getAuthor,
        setViews,
        searchPosts,
        setComment,
        getComments,
        getUser,
        getUserPosts,
      }}
    >
      {children}
    </Posts.Provider>
  );
};

export const UsePostsContext = () => useContext(Posts);
